// Angular import
import { Component, inject, Input, input, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { Location } from '@angular/common';

// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { MenuCollapseComponent } from '../menu-collapse/menu-collapse.component';
import { MenuItemVerticalComponent } from '../menu-item/menu-item.component';
import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-menu-group-vertical',
  imports: [SharedModule, MenuCollapseComponent, MenuItemVerticalComponent],
  templateUrl: './menu-group.component.html',
  styleUrls: ['./menu-group.component.scss']
})
export class MenuGroupVerticalComponent implements OnInit, AfterViewInit {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}
  private location = inject(Location);

  // public props

  // All Version in Group Name
  readonly item = input.required<NavigationItem>();

  current_url!: string;

  date: Date = new Date();
  now: number = this.date.getTime();
  targetDate: Date | null = null; // Inicializamos targetDate como null
  targetTime: number = 0; // Inicializamos targetTime en 0
  difference: number = 0;
  currentTime: string = '';
  months: string[] = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  // Referencias a los elementos HTML para mostrar la cuenta regresiva
  @ViewChild('days', { static: false }) days!: ElementRef;
  @ViewChild('hours', { static: false }) hours!: ElementRef;
  @ViewChild('minutes', { static: false }) minutes!: ElementRef;
  @ViewChild('seconds', { static: false }) seconds!: ElementRef;

  async obtenerCompensacion(): Promise<any> {
    try {
      let response = await firstValueFrom(this.http.get<any>(`${environment.apiUrl2}/compensacion/obtenerCompensacion`));

      return response;
    } catch (error) {
      console.error('Error al obtener compensación:', error);
      throw error; // Re-lanzamos el error para manejarlo en el lugar que llame a esta función
    }
  }

  async asignarTiempoFin() {
    try {
      // Obtener los datos de la API
      const data = await this.obtenerCompensacion();

      if (data.estado === 1) {
        // Convertir la fecha "fechaFin" de la respuesta en un objeto Date
        this.targetDate = new Date(data.fechaFin);

        // Asignar el tiempo en milisegundos de la fecha objetivo
        this.targetTime = this.targetDate.getTime();

        let hours = this.targetDate.getHours();
        let minutes = this.targetDate.getMinutes();

        // Formatear los minutos para que siempre tenga dos dígitos (por ejemplo, 09 en lugar de 9)
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        // Actualizar currentTime para incluir la hora y los minutos
        this.currentTime = `${this.months[this.targetDate.getMonth()]} ${this.targetDate.getDate()}  del ${this.targetDate.getFullYear()} ${hours}:${formattedMinutes}`;

        return data;
      } else {
        this.targetDate = null;
        return null;
      }
    } catch (error) {
      console.error('Error al asignar tiempo fin:', error);
    }
  }

  menuProductos(): void {
    this.router.navigate(['/productos/']);
  }

  actualizacionRealizada: boolean = false;

  ngAfterViewInit() {
    if (this.item()?.title === 'Trueque') {
      this.asignarTiempoFin()
        .then(() => {
          setInterval(() => {
            this.tickTock();
          }, 1000);
        })
        .catch((error) => {
          console.error('Hubo un error al asignar tiempo fin:', error);
        });
    }
  }

  async tickTock() {
    // Obtener el tiempo actual
    this.date = new Date();
    this.now = this.date.getTime();

    if (this.targetDate) {
      // Calcular la diferencia en milisegundos
      const differenceInMillis = this.targetTime - this.now;

      if (differenceInMillis > 0) {
        // Si la fecha objetivo no ha pasado, calculamos el tiempo restante
        const days = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24)); // Días restantes
        const hours = Math.floor((differenceInMillis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // Horas restantes
        const minutes = Math.floor((differenceInMillis % (1000 * 60 * 60)) / (1000 * 60)); // Minutos restantes
        const seconds = Math.floor((differenceInMillis % (1000 * 60)) / 1000); // Segundos restantes

        // Actualizar los elementos con los valores calculados
        if (this.days && this.days.nativeElement) {
          this.days.nativeElement.innerText = days.toString();
        }
        if (this.hours && this.hours.nativeElement) {
          this.hours.nativeElement.innerText = hours.toString();
        }
        if (this.minutes && this.minutes.nativeElement) {
          this.minutes.nativeElement.innerText = minutes.toString();
        }
        if (this.seconds && this.seconds.nativeElement) {
          this.seconds.nativeElement.innerText = seconds.toString();
        }
      } else {
        // Si la fecha objetivo ya pasó, mostramos 0 en todos los campos
        this.days.nativeElement.innerText = '00';
        this.hours.nativeElement.innerText = '00';
        this.minutes.nativeElement.innerText = '00';
        this.seconds.nativeElement.innerText = '00';
      }
    } else {
      // Si la fecha objetivo ya pasó, mostramos 0 en todos los campos
      this.days.nativeElement.innerText = '00';
      this.hours.nativeElement.innerText = '00';
      this.minutes.nativeElement.innerText = '00';
      this.seconds.nativeElement.innerText = '00';
    }
  }

  async cerrarPeriodoCompensacion() {
    const data = await this.obtenerCompensacion();

    const datos = {
      _id: data._id,
      estado: 0
    };

    try {
      let response = await firstValueFrom(
        this.http.post<any>(
          `${environment.apiUrl2}/compensacion/cerrarPeriodoCompensacion`, // Asegúrate de usar el endpoint correcto
          datos // Los datos que envías en el cuerpo
        )
      );

      Swal.fire({
        html: `<strong>Se cerró el perido de subida de facturas</strong>`,
        icon: 'success',
        confirmButtonText: '<i class="ti ti-check"></i> Entendido', // Ícono de confirmación
        confirmButtonColor: '#02294c' // Azul (Bootstrap primary)
      });
      this.asignarTiempoFin()
        .then((resultado) => {
          this.tickTock();
        })
        .catch((error) => {
          console.error('Hubo un error al asignar tiempo fin:', error);
        });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        html: `<strong>Error al obtener los datos del servidor<strong>`,
        customClass: {
          confirmButton: 'btn boton me-2 text-center mt-0',
          cancelButton: 'btn btn-danger text-center mt-0'
        },
        confirmButtonText: '<i class="ti ti-check"></i> Entendido', // Ícono de confirmación
        confirmButtonColor: '#02294c'
      });
      console.error('Error al consumir el servicio:', error);
    }
    // }
  }

  // Life cycle events
  ngOnInit() {
    this.current_url = this.location.path();
    //eslint-disable-next-line
    //@ts-ignore
    const baseHref = this.location['_baseHref'] || '';
    this.current_url = baseHref + this.current_url;

    // Use a more reliable way to find and update the active group
    setTimeout(() => {
      const links = document.querySelectorAll('a.nav-link') as NodeListOf<HTMLAnchorElement>;
      links.forEach((link: HTMLAnchorElement) => {
        if (link.getAttribute('href') === this.current_url) {
          let parent = link.parentElement;
          while (parent && parent.classList) {
            if (parent.classList.contains('coded-hasmenu')) {
              parent.classList.add('coded-trigger');
              parent.classList.add('active');
            }
            parent = parent.parentElement;
          }
        }
      });
    }, 0);
  }
}
